import { FeaturedFeedItemModel } from '../../models/FeaturedFeedItem.model';
import { feedItemService } from '../../services';

export const getCommunityPinnedFeedItem =
  async (): Promise<FeaturedFeedItemModel | null> => {
    const result = await feedItemService.fetchCommunityPinnedItem();

    if (result.isLeft()) {
      const error = result.value;
      throw new Error(error.message);
    } else {
      return result.value.getValue();
    }
  };

export const getCommunityPinnedFeedItems = async (): Promise<
  FeaturedFeedItemModel[]
> => {
  const result = await feedItemService.fetchCommunityPinnedItems();

  if (result.isLeft()) {
    const error = result.value;
    throw new Error(error.message);
  } else {
    return result.value.getValue();
  }
};
